import React, { useContext, useEffect } from "react";
import Helmet from "react-helmet";

import PageContext from "#components/PageContext";

export interface HelmetifyProps {
  name?: string;
  title?: string;
  path: string;
  iconName?: string;
}

const helmetify =
  <P extends HelmetifyProps>(WrappedComponent: React.ComponentType<P>) =>
  (props: P) => {
    const pageContext = useContext(PageContext);

    useEffect(() => {
      console.info("Mounting", props.name);
      if (pageContext.setActiveRouteDetails) {
        pageContext.setActiveRouteDetails({
          name: props?.name ?? "",
          title: props?.title ?? "",
          path: props?.path ?? "",
          iconName: props?.iconName ?? "",
        });
      }

      return () => {
        console.info("Unmounting", props.name);
      };
    }, [props.name, props.title, props.path, props.iconName]);

    return (
      <React.Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>{props.title}</title>
        </Helmet>
        <WrappedComponent {...props} />
      </React.Fragment>
    );
  };

export default helmetify;
